export const description = new Map([
  ['index', "El observatorio INNOTEC es un espacio virtual que tiene como objetivo monitorear la investigación y producción " +
  "científica de la UAPA a partir de la búsqueda, análisis y procesamiento de información, teniendo en cuenta un conjunto de " +
  "métricas e informaciones de interés para la universidad."],
  ['nosotros', 'La Vicerrectoría de Investigación y Postgrado fue creado en el año ' +
  '2013. Está sustentada en la filosofía de la UAPA que otorga gran importancia a la ' +
  'adecuada selección del cuerpo docente, a su capacitación, a la investigación, ' +
  'como mecanismo para garantizar la calidad de su labor docente y a la innovación ' +
  'como eje fundamental en un modelo de educación a distancia.'],
  ['herramientas', 'En esta sección se socializan plataformas que pueden ser útiles para la creación de perfiles para ' +
  'investigadores, programas gratuitos para detectar el plagio y plataformas para evaluar revistas que le permitan a los ' +
  'investigadores medir la visibilidad de la publicación donde desea publicar sus artículos.'],
  ['pc', 'La sección producción científica visualiza mediante gráficos y tablas la productividad de autores y la ' +
  'producción científica de los docentes de la UAPA  por tipo de actividad y por fecha de presentación.'],
  ['bp', 'Esta sección socializa al público y los tomadores de decisiones de la UAPA el conjunto de problemas que se ' +
  'pueden utilizar para dar respuesta a las convocatorias que financian la UAPA y organismo e instituciones nacionales e internaciones.'],
  ['proyectos', 'Esta sección tiene la finalidad de publicar todos los proyectos que ha realizado la\n' +
  'universidad. Los datos públicos que están disponibles de cada uno son: título, objetivo,\n' +
  'investigador principal, organización financiadora, año de aprobación del proyecto,\n' +
  'alcance y área de conocimiento a la que responde el proyecto.'],
  ["dr", 'Esta sección pone a disposición de los usuarios de la Universidad los informes de la\n' +
  'producción científica y un directorio de revistas que tiene la finalidad que tanto\n' +
  'investigadores y docentes seleccionen las revistas de su interés para la publicación de\n' +
  'sus resultados investigativos.'],
  ['ei', 'En la web existen observatorios que las temáticas que divulgan son de interés para la\n' +
  'comunidad académica y científica de la Universidad Abierta para Adultos. Desde estas\n' +
  'plataformas se puede tener acceso a libros, informes, innovaciones educativas y\n' +
  'memorias de eventos a texto completo.'],
  [3, 'three'],
])



// WEBPACK FOOTER //
// ./src/components/Header/dataHeader.js